var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManageAttendeeData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3341 14.6662V2.79956C20.5119 3.13289 23.1952 4.39956 25.3841 6.59956C27.573 8.79956 28.8452 11.4885 29.2008 14.6662H17.3341ZM14.7008 29.1662C11.323 28.8329 8.49523 27.4107 6.21745 24.8996C3.93967 22.3885 2.80078 19.4218 2.80078 15.9996C2.80078 12.5551 3.93967 9.57734 6.21745 7.06623C8.49523 4.55512 11.323 3.13289 14.7008 2.79956V29.1662ZM17.3341 29.1662V17.2996H29.2008C28.8897 20.4773 27.6286 23.1718 25.4174 25.3829C23.2063 27.594 20.5119 28.8551 17.3341 29.1662Z",
    fill: "#0057FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageAttendeeData);
export default __webpack_public_path__ + "static/media/manage-attendee-data.7b85fd8e9265e74483e4eba061fc9ce9.svg";
export { ForwardRef as ReactComponent };